import React from "react";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
import axiosInstance from "../utils/axiosInstance";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { setUserData, setUserDataError } from "../store/userSlice";
import { ensureKeypair } from "../crypto/cryptoKeys";
import { broadcastSessionChange, getHomePathForRole } from "../utils/sessionSync";
import { invalidateUserFetches, refreshSessionData } from "../utils/refreshSessionData";
import "../assets/css/style.css";
import "../assets/bp/BPEXCH-style.css";


const LoginSchema = Yup.object().shape({
  uname: Yup.string()
    .min(3, "")
    .matches(/^\S*$/, "Username cannot contain spaces")
    .required(""),
  passpin: Yup.string().min(2, "").required("")
});

// Login mutation function
const loginUser = async (values, publicJwk) => {
  const res = await axiosInstance.post(
    `${process.env.REACT_APP_API_URL}/api/auth/login`,
    { ...values, publicJwk },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true // <-- important for cookies
    }
  );
  console.log("getting in login: ", res.data);
  return res.data;
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [serverError, setServerError] = React.useState("");
  localStorage.removeItem("popupShown");

  // Use React Query's useMutation without onSuccess/onError in the hook itself
  const { mutate, isLoading } = useMutation({
    mutationFn: async (values) => {
      const { publicJwk } = await ensureKeypair(); // generate before login
      await axiosInstance.post("crypto/register-key", { publicJwk });
      return loginUser(values, publicJwk);
    }
  });
  return (
    <div
      style={{
        backgroundImage: "url('/assets/images/Login-bg.jpg')",
        backgroundSize: "cover",
        minHeight: "100vh"
      }}
    >
      <style>{`
       input:-webkit-autofill,
       input:-webkit-autofill:hover,
       input:-webkit-autofill:focus,
       textarea:-webkit-autofill,
       select:-webkit-autofill {
           -webkit-text-fill-color: #fff;
           -webkit-box-shadow: 0 0 0px 1000px transparent inset;
           transition: background-color 5000s ease-in-out 0s;
       }


`}</style>
      <section className="login-section-wrapper">
        <div className="container">
          <div className="row">
            <div className="login-section-row">
              <div className="wrap-login100">
                <Formik
                  initialValues={{ uname: "", passpin: "" }}
                  validationSchema={LoginSchema}
                  onSubmit={(values, actions) => {
                    setServerError("");
                    mutate(values, {
                      onSuccess: async (data) => {
                        actions.setSubmitting(false); // inform Formik!
                        console.log("Login successful:", data);
                        const user = data.user;

                        invalidateUserFetches();
                        await dispatch(setUserData(user));
                        broadcastSessionChange(user);
                        await refreshSessionData(dispatch);
                        navigate(getHomePathForRole(user.user_role), {
                          replace: true,
                        });
                      },
                      onError: (error) => {
                        actions.setSubmitting(false); // inform Formik!
                        setServerError(
                          error?.response?.data?.message ||
                            "Username/Password Incorrect."
                        );
                      }
                    });
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form
                      id="loginPagefrm"
                      name="loginPagefrm"
                      className="login-form login-form-mobile-views"
                      noValidate
                    >
                      <span
                        className="login100-form-logo"
                        style={{
                          paddingBottom: "13px",
                          backgroundColor: "transparent"
                        }}
                      >
                        <img
                          src={process.env.REACT_APP_LOGO_URL}
                          alt="Logo"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "60px"
                          }}
                        />
                      </span>

                      <div
                        className="wrap-input100 username validate-input"
                        data-validate="Enter username"
                      >
                        <Field
                          className="input100"
                          type="text"
                          placeholder="Username"
                          id="uname"
                          name="uname"
                          autoComplete="username"
                        />
                        <span
                          className="focus-input100"
                          data-placeholder=""
                        ></span>
                        <ErrorMessage
                          name="uname"
                          component="div"
                          className="text-danger"
                          style={{ fontSize: "14px" }}
                        />
                      </div>

                      <div
                        className="wrap-input100-password validate-input"
                        data-validate="Enter password"
                      >
                        <Field
                          className="input100-password input-row inputData1"
                          type="password"
                          placeholder="Password"
                          name="passpin"
                          id="passpin"
                          autoComplete="current-password"
                        />
                        <span
                          className="focus-input100-password"
                          data-placeholder=""
                        ></span>
                        <ErrorMessage
                          name="passpin"
                          component="div"
                          className="text-danger"
                          style={{ fontSize: "14px" }}
                        />
                      </div>

                      <div className="container-login100-form-btn">
                        <button
                          type="submit"
                          className="login100-form-btn"
                          id="btnLogin_page"
                          disabled={isSubmitting || isLoading}
                        >
                          {isSubmitting || isLoading ? "Login" : "Login"}
                        </button>
                      </div>

                      <div
                        className="text-center p-t-10"
                        style={{ marginTop: "20px" }}
                      >
                        <div
                          className="text-danger validation-summary-valid"
                          style={{ fontSize: "20px" }}
                          data-valmsg-summary="true"
                        >
                          <ul>
                            {serverError && (
                              <li style={{ display: "block" }} id="errorBox">
                                {serverError}
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
